export function changeCurrentTimeInCurrentMonth(date: Date): Date {
  if (date.getFullYear() === new Date().getFullYear() &&
    date.getMonth() === new Date().getMonth()) {
    date = new Date()
  }
  return date
}

export function addMonths(date: Date, months: number): Date {
  const d = date.getDate();
  date.setMonth(date.getMonth() + +months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  return date;
}

export function toLocalDateString(date: Date): string {
    return date.toISOString().split('T')[0];
}

export function toYearMonthString(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    return `${year}-${month}`;
}
